import {getTimeOfDay, safeParse} from "../utils/date-formatters.mjs";

export default async function getPerformances() {
    try {
        const response = await fetch('/api/event-instances.json');
        const data = await response.json();

        return processPerformances(data.docs);
    } catch (error) {
        console.error('Failed to load events:', error);

        throw error;
    }
}

function processPerformances(performances) {
    const now = new Date();

    return performances
        .map(performance => {
            const startDate = safeParse(performance.startDateLocalAsUTC);

            performance.startDate = startDate;
            performance.timeOfDay = getTimeOfDay(startDate);

            if (AppConfig.boDomain) {
                performance.bookButton = {
                    title: 'Buy Buttons',
                    link: `${AppConfig.boDomain.replace(/^\/|\/$/g, '')}/booking/production/${performance.tessitura.performanceId}`
                };
            } else if (AppConfig.tnewDomain) {
                performance.bookButton = {
                    title: 'Buy Buttons',
                    link: `${AppConfig.tnewDomain.replace(/^\/|\/$/g, '')}/${performance.tessitura.productionSeasonId}/${performance.tessitura.performanceId}`
                };
            } else {
                performance.bookButton = null;
            }

            if (parseInt(performance.tessitura.availability, 10) === 0) {
                performance.isSoldOut = true;
            }

            return performance;
        })
        .filter(performance => performance.startDate >= now);
}
